import {AxiosError} from 'axios'
import {toast} from 'react-hot-toast'

export function setupAxios(axios: any, getToken: () => Promise<string | null>) {
  axios.defaults.headers.Accept = 'application/json'

  const requestInterceptor = axios.interceptors.request.use(
    async (config: any) => {
      try {
        const token = await getToken()

        if (token) {
          config.headers.Authorization = `Bearer ${token}`
        }

        return config
      } catch {
        return config
      }
    },
    (err: any) => Promise.reject(err)
  )

  const responseInterceptor = axios.interceptors.response.use(
    (response: any) => response,
    (error: AxiosError<any>) => {
      if (error.response?.data?.detail) {
        toast.error(error.response.data.detail)
      }

      if (error.response?.status === 401) {
        window.location.href = '/auth/login'
      }

      return Promise.reject(error)
    }
  )
  return () => {
    axios.interceptors.request.eject(requestInterceptor)
    axios.interceptors.response.eject(responseInterceptor)
  }
}
